import { Routes, UrlSegment } from '@angular/router';
import { AuthGuardService as AuthGuard } from './_services/auth-guard.service';
import { LoginComponent } from './components/general/login/login.component';
import { DashboardComponent } from './components/general/dashboard/dashboard.component';
import { HomeComponent } from './components/general/home/home.component';


import { Permits } from 'src/domain/enums/Permits.enum';

import { JavaRedirectComponent } from './components/java-redirect/java-redirect.component';
import { SetupHpComponent } from './components/setup-hp/setup-hp.component';
import { SetupHpEditComponent } from './components/setup-hp/setup-hp-edit/setup-hp-edit.component';
import { SurveyEditComponent } from './components/surveys/survey-edit/survey-edit.component';
import { TargetEditComponent } from './components/targets/target-edit/target-edit.component';
import { SurveyModelsComponent } from './components/survey-models/survey-models.component';
import { SurveyModelEditComponent } from './components/survey-models/survey-model-edit/survey-model-edit.component';
import { SurveyStartupModelEditComponent } from './components/survey-startup-models/survey-startup-model-edit/survey-startup-model-edit.component';
import { SurveyStartupModelsComponent } from './components/survey-startup-models/survey-startup-models.component';
import { SurveysComponent } from './components/surveys/surveys/surveys.component';
import { TargetsComponent } from './components/targets/targets.component';
import { RsaComponent } from './components/rsa/rsa.component';
import { SmsComponent } from './components/sms/sms.component';
import { EmailCampaignsComponent } from './components/email-campaigns/email-campaigns.component';
import { SmsEditComponent } from './components/sms/sms-edit/sms-edit.component';
import { RsaEditComponent } from './components/rsa/rsa-edit/rsa-edit.component';
import { ChecklModelEditComponent } from './components/checklists/checkl-model-edit/checkl-model-edit.component';
import { ChecklModelsComponent } from './components/checklists/checkl-models/checkl-models.component';
import { ChecklComponent } from './components/checklists/checkl/checkl.component';
import { ChecklEditComponent } from './components/checklists/checkl-edit/checkl-edit.component';
import { ChecklResultsComponent } from './components/checklists/checkl-results/checkl-results.component';
import { SurveysResultsComponent } from './components/surveys/surveys-results/surveys-results.component';
import { CampaignEditComponent } from './components/email-campaigns/campaign-edit/campaign-edit.component';

import { OrdiniComponent } from './components/ordini/ordini.component';
import { ManutenzioniComponent } from './components/manutenzioni/manutenzioni.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { RecruitingComponent } from './components/recruiting/recruiting.component';
import { ArkiguestComponent } from './components/arkiguest/arkiguest.component';
import { SegnalazioniComponent } from './components/segnalazioni/segnalazioni.component';
import { NonconformitaComponent } from './components/nonconformita/nonconformita.component';
import { SurveyModelSettingsComponent } from './components/survey-models/survey-model-settings/survey-model-settings.component';
import { SurveyResultsPptxComponent } from './components/surveys/surveys/survey-results-pptx/survey-results-pptx.component';
import { SurveysEmailsnotsentComponent } from './components/surveys/surveys-emailsnotsent/surveys-emailsnotsent.component';
import { OrganizationComponent } from './components/admin/organization/organization.component';
import { AdminComponent } from './components/admin/admin.component';
import { ArkiwebappsComponent } from './components/admin/arkiwebapps/arkiwebapps.component';
import { ArkiwebrolesComponent } from './components/admin/arkiwebroles/arkiwebroles.component';
import { DaApprovareComponent } from './components/da-approvare/da-approvare.component';
import { OrganizationdiagramComponent } from './components/admin/organizationdiagram/organizationdiagram.component';
import { QualificheutentiComponent } from './components/admin/qualificheutenti/qualificheutenti.component';
import { SurveyCompilationsComponent } from './components/surveys/surveycompilations/surveycompilations.component';
import { SurveyViewCompilationComponent } from "./components/surveys/surveyviewcompilation/surveyviewcompilation.component";
import { SurveyStartupModelSettingsComponent } from './components/survey-startup-models/survey-startup-model-settings/survey-startup-model-settings.component';
import { MonitorsComponent } from './components/monitors/monitors.component';
import { RulesComponent } from './components/monitors/rules/rules.component';
import { PlaylistsComponent } from './components/monitors/playlists/playlists.component';
import { MonitorEditComponent } from './components/monitors/monitor-edit/monitor-edit.component';
import { RuleEditComponent } from './components/monitors/rules/rule-edit/rule-edit.component';
import { PlaylistEditComponent } from './components/monitors/playlists/playlist-edit/playlist-edit.component';
import { RicetteComponent } from './components/gestione-mensa/ricette/ricette.component';
import { RicetteEditComponent } from './components/gestione-mensa/ricette/ricette-edit/ricette-edit.component';
import { PrenotazioniComponent } from './components/gestione-mensa/prenotazioni/prenotazioni.component';
import { ProgrammazioneComponent } from './components/gestione-mensa/programmazione/programmazione.component';
import { ProgrammazioneEditComponent } from './components/gestione-mensa/programmazione/programmazione-edit/programmazione-edit.component';
import { ProgrammazioneCalendarComponent } from './components/gestione-mensa/programmazione/programmazione-calendar/programmazione-calendar.component';
import { ProgrammaComponent } from './components/gestione-mensa/programma/programma.component';
import { ProgrammaEditComponent } from './components/gestione-mensa/programma/programma-edit/programma-edit.component';
import { SetupComponent } from './components/gestione-mensa/setup/setup.component';
import { TipimonitorsComponent } from './components/monitors/tipimonitors/tipimonitors.component';
import { MonitorReportComponent } from './components/monitors/monitor-report/monitor-report.component';
import { MonitorSetupComponent } from './components/monitors/monitor-setup/monitor-setup.component';
import { AppsComponent } from './components/admin/apps/apps.component';
import { ApppermitEditComponent } from './components/admin/apppermit-edit/apppermit-edit.component';
import { AppEditComponent } from './components/admin/app-edit/app-edit.component';
import { CapienzeComponent } from './components/gestione-mensa/capienze/capienze.component';
import { SospensioniComponent } from './components/gestione-mensa/sospensioni/sospensioni.component';
import { SospensioniEditComponent } from './components/gestione-mensa/sospensioni/sospensioni-edit/sospensioni-edit.component';

export function linkToJava(url: UrlSegment[]) {

  return url.length > 1 && ((url[0].path=='java')) ? ({consumed: url}) : null;
}

export const appRoutes: Routes = [
    {matcher: linkToJava, component: JavaRedirectComponent},
    {path: '', component: LoginComponent},



    {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], children: [
      {path: '', component: HomeComponent, canActivate: [AuthGuard] },
   
      {path: 'tipimonitors', component: TipimonitorsComponent, canActivate: [AuthGuard]},

      
      {path: 'monitors', component: MonitorsComponent, canActivate: [AuthGuard]},
      {path: 'monitors/setup', component: MonitorSetupComponent, canActivate: [AuthGuard]},
      {path: 'monitors/monitor-edit/:action', component: MonitorEditComponent, canActivate: [AuthGuard]},
      {path: 'monitors/monitor-edit/:action/:id', component: MonitorEditComponent, canActivate: [AuthGuard]},
      {path: 'monitors/monitor-report/:id', component: MonitorReportComponent, canActivate: [AuthGuard]},
      {path: 'monitors/rules', component: RulesComponent, canActivate: [AuthGuard]},
      {path: 'monitors/rule-edit/:action', component: RuleEditComponent, canActivate: [AuthGuard]},
      {path: 'monitors/rule-edit/:action/:id', component: RuleEditComponent, canActivate: [AuthGuard]},
      {path: 'monitors/playlists', component: PlaylistsComponent, canActivate: [AuthGuard]},
      {path: 'monitors/playlist-edit/:action', component: PlaylistEditComponent, canActivate: [AuthGuard]},
      {path: 'monitors/playlist-edit/:action/:id', component: PlaylistEditComponent, canActivate: [AuthGuard]},
       
      {path: 'gestionemensa/setup', component: SetupComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/ricette', component: RicetteComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/ricette/ricette-edit/:action', component: RicetteEditComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/ricette/ricette-edit/:action/:id', component: RicetteEditComponent, canActivate: [AuthGuard]},

      {path: 'gestionemensa/programmazione', component: ProgrammazioneComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/programmazione/programmazione-edit/:action/:struttura_name/:struttura_id/:id', component: ProgrammazioneEditComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/programmazione/programmazione-edit/:action/:struttura_name/:struttura_id', component: ProgrammazioneEditComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/programmazione-calendar', component: ProgrammazioneCalendarComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/programma', component: ProgrammaComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/programma-edit/:action/:struttura_name/:struttura_id', component: ProgrammaEditComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/programma-edit/:action/:struttura_name/:struttura_id/:id', component: ProgrammaEditComponent, canActivate: [AuthGuard]},

      {path: 'gestionemensa/prenotazioni', component: PrenotazioniComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/prenotazioni/prenotazioni-edit/:action', component: PrenotazioniComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/prenotazioni/prenotazioni-edit/:action/:id', component: PrenotazioniComponent, canActivate: [AuthGuard]},
    
      {path: 'gestionemensa/sospensioni', component: SospensioniComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/sospensioni/sospensioni-edit/:action/:struttura_name/:struttura_id/:id', component: SospensioniEditComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/sospensioni/sospensioni-edit/:action/:struttura_name/:struttura_id', component: SospensioniEditComponent, canActivate: [AuthGuard]},
      {path: 'gestionemensa/capienze', component: CapienzeComponent, canActivate: [AuthGuard]},

      {path: 'admin', children: [
        {path: '', component: AdminComponent, canActivate: [AuthGuard] },
        {path: 'organization-tree', component: OrganizationComponent, canActivate: [AuthGuard]},
        {path: 'organization-tree/:filtro', component: OrganizationComponent, canActivate: [AuthGuard]},
        {path: 'organization-diagram', component: OrganizationdiagramComponent, canActivate: [AuthGuard]},
        {path: 'arkiwebapps', component: ArkiwebappsComponent, canActivate: [AuthGuard]},
        {path: 'arkiwebqualifiche', component: QualificheutentiComponent, canActivate: [AuthGuard]},
        {path: 'arkiwebroles', component: ArkiwebrolesComponent, canActivate: [AuthGuard]},
      ]},  
      


      {path: 'surveys', children: [
        {path: 'survey-startup-models', component: SurveyStartupModelsComponent, canActivate: [AuthGuard]},
        {path: 'survey-startup-models-edit/:action', component: SurveyStartupModelEditComponent, canActivate: [AuthGuard]},
        {path: 'survey-startup-models-edit/:action/:id', component: SurveyStartupModelEditComponent, canActivate: [AuthGuard]},
        {path: 'survey-startup-models-settings/:id', component: SurveyStartupModelSettingsComponent, canActivate: [AuthGuard]},

        {path: 'survey-models', component: SurveyModelsComponent, canActivate: [AuthGuard]},
        {path: 'survey-models-edit/:action', component: SurveyModelEditComponent, canActivate: [AuthGuard]},
        {path: 'survey-models-edit/:action/:id', component: SurveyModelEditComponent, canActivate: [AuthGuard]},
        {path: 'survey-settings/:id', component: SurveyModelSettingsComponent, canActivate: [AuthGuard]},

      
        {path: 'surveys', component: SurveysComponent, canActivate: [AuthGuard]},
        {path: 'surveycompilations/:id', component: SurveyCompilationsComponent, canActivate: [AuthGuard]},
        {path: 'surveyviewcompilation/:id', component: SurveyViewCompilationComponent, canActivate: [AuthGuard]},
        {path: 'surveys-results', component: SurveysResultsComponent, canActivate: [AuthGuard]},
        {path: 'surveys-emailsnotsent/:id', component: SurveysEmailsnotsentComponent, canActivate: [AuthGuard]},
        {path: 'surveys-results-pptx', component: SurveyResultsPptxComponent, canActivate: [AuthGuard]},
        {path: 'survey-edit/:action', component: SurveyEditComponent, canActivate: [AuthGuard]},
        {path: 'survey-edit/:action/:id', component: SurveyEditComponent, canActivate: [AuthGuard]},
        
        {path: 'targets', component: TargetsComponent, canActivate: [AuthGuard]},
        {path: 'target-edit/:action', component: TargetEditComponent, canActivate: [AuthGuard]},
        {path: 'target-edit/:action/:id', component: TargetEditComponent, canActivate: [AuthGuard]},

        

        {path: 'rsa', component: RsaComponent, canActivate: [AuthGuard]},
        {path: 'rsa-edit/:action', component: RsaEditComponent, canActivate: [AuthGuard]},
        {path: 'rsa-edit/:action/:id', component: RsaEditComponent, canActivate: [AuthGuard]},

        {path: 'sms', component: SmsComponent, canActivate: [AuthGuard]},
        {path: 'sms-edit/:action', component: SmsEditComponent, canActivate: [AuthGuard]},
        {path: 'sms-edit/:action/:id', component: SmsEditComponent, canActivate: [AuthGuard]},
     
        {path: 'email-campaigns', component: EmailCampaignsComponent, canActivate: [AuthGuard]},
        {path: 'email-campaigns-edit/:action', component: CampaignEditComponent, canActivate: [AuthGuard]},
        {path: 'email-campaigns-edit/:action/:id', component: CampaignEditComponent, canActivate: [AuthGuard]},


        
        {path: 'email-campaigns', component: EmailCampaignsComponent, canActivate: [AuthGuard]},
        {path: 'email-campaigns-edit/:action', component: EmailCampaignsComponent, canActivate: [AuthGuard]},
        {path: 'email-campaigns-edit/:action/:id', component: EmailCampaignsComponent, canActivate: [AuthGuard]},


      ]},
      {path: 'checklists', children: [
        {path: 'checkl-models', component: ChecklModelsComponent, canActivate: [AuthGuard]},
        {path: 'checkl-model-edit/:action', component: ChecklModelEditComponent, canActivate: [AuthGuard]},
        {path: 'checkl-model-edit/:action/:id', component: ChecklModelEditComponent, canActivate: [AuthGuard]},
        {path: 'checkl', component: ChecklComponent, canActivate: [AuthGuard]},
        {path: 'checkl-edit/:action', component: ChecklEditComponent, canActivate: [AuthGuard]},
        {path: 'checkl-edit/:action/:id', component: ChecklEditComponent, canActivate: [AuthGuard]},
        {path: 'checkl-results', component: ChecklResultsComponent, canActivate: [AuthGuard]},
       

      ]},
     


      {path: 'setup-hp', children: [
        {path: 'list', component: SetupHpComponent, canActivate: [AuthGuard]},
        {path: 'setup-hp-edit/:action/:id', component: SetupHpEditComponent, canActivate: [AuthGuard]},
        {path: 'setup-hp-edit/:action', component: SetupHpEditComponent, canActivate: [AuthGuard]},
       
      ]},

      
      {path: 'recruiting', component: RecruitingComponent, canActivate: [AuthGuard] },
      {path: 'ordini', component: OrdiniComponent, canActivate: [AuthGuard] },
      {path: 'manutenzioni', component: ManutenzioniComponent, canActivate: [AuthGuard] },
      {path: 'manutenzioni/:filter', component: ManutenzioniComponent, canActivate: [AuthGuard] },
      {path: 'tickets', component: TicketsComponent, canActivate: [AuthGuard] },
      {path: 'daapprovare', component: DaApprovareComponent, canActivate: [AuthGuard] },
      
      {path: 'recruiting', component: RecruitingComponent, canActivate: [AuthGuard] },
      {path: 'arkiguest', component: ArkiguestComponent, canActivate: [AuthGuard] },
      {path: 'segnalazioni', component: SegnalazioniComponent, canActivate: [AuthGuard] },
      {path: 'nonconformita', component: NonconformitaComponent, canActivate: [AuthGuard] },
     
      {path: 'adminapps', component: AppsComponent, canActivate: [AuthGuard] },
      {path: 'adminapps', component: AppsComponent, canActivate: [AuthGuard] },
      {path: 'adminapp-edit/:action/:id', component: AppEditComponent, canActivate: [AuthGuard] },
      {path: 'adminapp-edit/:action', component: AppEditComponent, canActivate: [AuthGuard] },
      {path: 'adminapps-permits-edit/:app_id/:nomeapp/:action/:id', component: ApppermitEditComponent, canActivate: [AuthGuard]},
      {path: 'adminapps-permits-edit/:app_id/:nomeapp/:action', component: ApppermitEditComponent, canActivate: [AuthGuard]},


    ]},
    
   

    {path: '**', redirectTo: 'dashboard', pathMatch: 'full'}
];
